var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 8.66667V4.00001C13.3334 3.64638 13.1929 3.30724 12.9429 3.0572C12.6928 2.80715 12.3537 2.66667 12.0001 2.66667H4.00008C3.64646 2.66667 3.30732 2.80715 3.05727 3.0572C2.80722 3.30724 2.66675 3.64638 2.66675 4.00001V8.66667M13.3334 8.66667V12C13.3334 12.3536 13.1929 12.6928 12.9429 12.9428C12.6928 13.1929 12.3537 13.3333 12.0001 13.3333H4.00008C3.64646 13.3333 3.30732 13.1929 3.05727 12.9428C2.80722 12.6928 2.66675 12.3536 2.66675 12V8.66667M13.3334 8.66667H11.6094C11.4326 8.66671 11.2631 8.73697 11.1381 8.86201L9.52875 10.4713C9.40375 10.5964 9.23421 10.6666 9.05742 10.6667H6.94275C6.76595 10.6666 6.59641 10.5964 6.47141 10.4713L4.86208 8.86201C4.73709 8.73697 4.56754 8.66671 4.39075 8.66667H2.66675",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxOutline);
export default __webpack_public_path__ + "static/media/InboxOutline.df2de30249432588b69ca4d76bdb1df8.svg";
export { ForwardRef as ReactComponent };